module.exports = __webpack_public_path__ + "lightBulb.webp?a168ded1ed6256186dc6ed99afd09140";